<template>
  <div id="app">
    <div v-if="updateExists" class="pwa-update">
        <div class="content bottom-0 center-horizontal">
            <p class="center-text top-50"><i class="fa fa-sync-alt fa-7x color-highlight fa-spin"></i></p>
            <h1 class="center-text top-50 ultrabold">Oppdatering tilgjengelig</h1>
            <p class="center-text">
                En ny version av appen er tilgjenglig. Ikke bekymre deg, du trenger ikke gjøre noe. Bare trykk på "oppdater" så gjør vi alt for deg.
            </p>
            <a @click="refreshApp" class="page-update uppercase ultrabold round-small shadow-huge button button-xs button-full bg-blue2-dark">Oppdater</a>
            <p class="center-text font-10 bottom-0">Appen vil lastes på nytt, og oppdateringen vil være fullført.</p>
        </div>
    </div>
    <router-view/>
  </div>
</template>

<script>
export default {
    data(){
        return{
            refreshing: false,
            registration: null,
            updateExists: false
        }
    },
    created () {
        document.addEventListener(
            'swUpdated', this.showRefreshUI, { once: true }
        );
        navigator.serviceWorker.addEventListener(
            'controllerchange', () => {
            if (this.refreshing) return;
            this.refreshing = true;
            window.location.reload();
            }
        );
    },
    methods: {
        showRefreshUI (e) {
            // Display a button inviting the user to refresh/reload the app due
            // to an app update being available.
            // The new service worker is installed, but not yet active.
            // Store the ServiceWorkerRegistration instance for later use.
            this.registration = e.detail;
            this.updateExists = true;
        },
        refreshApp () {
            // Handle a user tap on the update app button.
            this.updateExists = false;
            // Protect against missing registration.waiting.
            if (!this.registration || !this.registration.waiting) { return; }
            this.registration.waiting.postMessage('skipWaiting');
        },
    }
}
</script>


<style>
/* @import url('./assets/styles/style.css'); */
/* @import url('./assets/styles/framework.css'); */
*,
*::before,
*::after {
    box-sizing: border-box;
}

html {
    font-size: 100%;
}
.page-content{
  max-width: 700px;
  margin: auto;
  
}
.padding-sides{
    padding-left: 2em;
    padding-right: 2em;
}
.pwa-update{
    position: absolute
}

/* #page {
    display: block;
    background-color: #FFF;
    left: 0px;
    right: 0px;
    overflow: hidden;
}*/
.header-clear-large {
    padding-top: 90px;
}
/*.page-content {
    box-shadow: 0 0px 0px 0 rgba(0,0,0,0.11);
    z-index: 98;
}
.page-content {
    background-color: #FFF;
    transition: transform 300ms ease;
}
.caption {
    z-index: 2;
    margin-bottom: 30px;
    overflow: hidden;
}
.landing-header {
    margin-bottom: 50px;
}
.landing-icons {
    max-width: 320px;
    margin: auto;
}
.color-theme {
    color: #1f1f1f!important;
}
.landing-icons a {
    width: 33.3%;
    display: block;
    float: left;
    margin-bottom: 8%;
}
a {
    text-decoration: none;
}

a {
    color: #2980b9;
}
.landing-icons a i {
    width: 60px;
    height: 60px;
    display: block;
    margin: 0 auto;
    text-align: center;
    border-radius: 60px;
    line-height: 60px;
    font-size: 22px;
    color: #FFFFFF;
}
.bg-red2-light {
    background-color: #ED5565!important;
    color: #FFFFFF!important;
}
.landing-icons a em {
    display: block;
    text-align: center;
    font-size: 13px;
    font-style: normal;
    margin-top: 5px;
}
.color-theme {
    color: #1f1f1f!important;
}
h2 {
    font-size: 21px;
    line-height: 25px;
}
.text-center, .center-text {
    text-align: center;
    display: block;
}
h1, h2, h3, h4, h5, h6 {
    font-family: 'Poppins', sans-serif;
    margin-bottom: 5px;
    letter-spacing: -0.3px;
    font-weight: 500;
}
.landing-header a img {
    width: 215px;
    margin: 0 auto;
}
.header-logo-app .header-title {
    left: 0px!important;
    margin-left: 55px!important;
}
.header .header-title, .header-nav .header-title {
    position: absolute;
    height: 56px;
    line-height: 56px;
    font-size: 13px;
    color: #000;
    font-weight: 600;
    z-index: 1;
    font-family: 'Poppins', sans-serif;
}
.header-logo-app .header-icon-1 {
    left: 3px;
}
.header .header-icon, .header-nav .header-icon {
    position: absolute;
    height: 55px;
    width: 45px;
    text-align: center;
    line-height: 54px;
    font-size: 12px;
    color: #1f1f1f;
}
.header-clear-medium {
    padding-top: 75px;
}
.divider-margins {
    margin: 0px 15px 30px 15px;
}
.content {
    margin: 0px 15px 30px 15px;
}
.divider {
    height: 1px;
    display: block;
    background-color: rgba(0,0,0,0.06);
    margin-bottom: 30px;
} */
</style>
